import axios from "axios";
import { createAction } from "@coverme/redux";

export const saveFaDocumentation = (encounterId, documents) =>
    createAction("SAVE_FA_DOCUMENTATION", () => {
        return axios.delete(`/api/encounter/${encounterId}/encounterDocuments`).then(() => {
            return axios.post(`/api/encounter/${encounterId}/encounterDocuments`, documents);
        });
    });

export const getFaDocumentation = encounterId => {
    return createAction("GET_FA_DOCUMENTATION", () => {
        return axios.get(`/api/encounter/${encounterId}/encounterDocuments`).then(data => data.data);
    });
};
